import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Checkbox,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import ExcludeUser from './ExcludeUser';
import ChangeReviewer from './ChangeReviewer';
import IncludeUser from './IncludeUser';
import { useDispatch, useSelector } from 'react-redux';
import { getAllEvaluationcycle, getCycleAssignedUsers } from '../../../../../redux/features/appraisalSlice';
import GlobalWrapper from '../../../../../components/Wrapper/GlobalWrapper';
import Loader3D from '../../../../../components/Loader/Loader3D';
import NoDataFound from '../../../../../components/NodataIndication/NoDataFound';

const ManageUser = ({ open, setOpen, id, status }) => {
  const dispatch = useDispatch();
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [updateValidation, setUpdateValidation] = useState(false);
  // Text typed in the search box. Used to filter the assigned-users table by name.
  const [searchQuery, setSearchQuery] = useState('');
  const { cycleAssignedUsers, loading } = useSelector((state) => state.appraisal);

  useEffect(() => {
    if (open) {
      dispatch(getCycleAssignedUsers(id));
    }
    if (!open && updateValidation) {
      dispatch(getAllEvaluationcycle());
    }
    // Clear the search text every time the popup closes so it starts fresh next time.
    if (!open) {
      setSearchQuery('');
    }
  }, [open]);

  // Filter the assigned users by the typed name (case-insensitive). This is a pure
  // front-end filter over the already-loaded list, so it does not call the backend.
  const query = searchQuery.trim().toLowerCase();
  const filteredUsers = query
    ? cycleAssignedUsers.filter((user) => (user.assigned_user || '').toLowerCase().includes(query))
    : cycleAssignedUsers;

  const handleCheckboxChange = (userId) => {
    setSelectedUserIds((prevSelected) =>
      prevSelected.includes(userId) ? prevSelected.filter((id) => id !== userId) : [...prevSelected, userId],
    );
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={'Manage User'}
      fullScreen
      closeButton={true}
      content={
        <>
          {open ? (
            <GlobalWrapper>
              {/* {loading ? (
                <Loader3D />
              ) : ( */}
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'row',
                    gap: 2,
                  }}
                >
                  {/* Left side: search box to filter the assigned users by name */}
                  <TextField
                    size="small"
                    placeholder="Search user by name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    sx={{ width: { xs: '100%', sm: 300 } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon icon="mdi:magnify" width="20" height="20" />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* Right side: bulk exclude (when 2+ selected) and the Include User button */}
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                    {selectedUserIds.length > 1 ? (
                      <ExcludeUser
                        ids={selectedUserIds}
                        setSelectedUserIds={setSelectedUserIds}
                        cycleId={id}
                        setUpdateValidation={setUpdateValidation}
                      />
                    ) : null}
                    {status === 2 ? null : <IncludeUser cycleId={id} setUpdateValidation={setUpdateValidation} />}
                  </Box>
                </Box>
                <Box p={2}>
                  {cycleAssignedUsers.length === 0 ? (
                    <NoDataFound />
                  ) : (
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                          <TableRow>
                            <TableCell>check</TableCell>
                            <TableCell>User ID</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>User Role</TableCell>
                            <TableCell>Reviewer</TableCell>
                            <TableCell>Manager Review Status</TableCell>
                            <TableCell>Change Reviewer</TableCell>
                            <TableCell>Exclude User</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {filteredUsers.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={8} align="center">
                                No users match "{searchQuery}"
                              </TableCell>
                            </TableRow>
                          ) : (
                            filteredUsers.map((user) => (
                            <TableRow key={user.userId}>
                              <TableCell>
                                <Checkbox
                                  disabled={status === 2 ? true : false}
                                  checked={selectedUserIds.includes(user.appraisal_cycle_assignment_id)}
                                  onChange={() => handleCheckboxChange(user.appraisal_cycle_assignment_id)}
                                />
                              </TableCell>
                              <TableCell>{user.userID}</TableCell>
                              <TableCell>{user.assigned_user}</TableCell>
                              <TableCell>{user.designationName}</TableCell>
                              <TableCell>{user.manager_name}</TableCell>
                              <TableCell>
                                {user.review_status === 0
                                  ? 'Pending'
                                  : user.review_status === 1
                                    ? 'Self Reviewed'
                                    : 'Manager Reviewed'}
                              </TableCell>
                              <TableCell>
                                {status === 2 ? null : <ChangeReviewer cycleId={id} userId={user.userID} />}
                              </TableCell>
                              <TableCell>
                                {status === 2 ? null : (
                                  <ExcludeUser
                                    ids={[user.appraisal_cycle_assignment_id]}
                                    setSelectedUserIds={setSelectedUserIds}
                                    cycleId={id}
                                  />
                                )}
                              </TableCell>
                            </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Box>
              </Box>
              {/* )} */}
            </GlobalWrapper>
          ) : null}
        </>
      }
    />
  );
};

export default ManageUser;
